var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStaff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#ED1B2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#staff_svg__clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 22.833a5.423 5.423 0 01-5.417-5.416A5.423 5.423 0 0121.75 12a5.423 5.423 0 015.417 5.417 5.423 5.423 0 01-5.417 5.416zM17.146 25A5.15 5.15 0 0012 30.146v3.792c0 .444.368.812.813.812h10.02v-3.52c0-2.037 1.517-3.717 3.478-4.01a4.167 4.167 0 011.495-2.014c-1.084-.31-1.142-.206-10.66-.206zM36.104 29.333H34.75v-.812c0-1.046-.85-1.896-1.896-1.896h-2.708c-1.046 0-1.896.85-1.896 1.896v.812h-1.354c-.533 0-1.013.222-1.358.578l5.962 3.11 5.962-3.11a1.884 1.884 0 00-1.358-.578zm-6.229 0v-.812c0-.15.121-.271.27-.271h2.71c.149 0 .27.121.27.27v.813h-3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.876 34.658a.813.813 0 01-.75 0L25 31.462v4.642C25 37.15 25.85 38 26.896 38h9.208C37.15 38 38 37.15 38 36.104v-4.642l-6.124 3.196z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "staff_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12 12)",
    d: "M0 0h26v26H0z"
  })))));
}

export default SvgStaff;